export interface TaskFiltersDashboardState {
  agencyIds?: string[];
  assignedToUserIds?: string[];
}

type StoredTaskFiltersDashboardState = Omit<TaskFiltersDashboardState, 'agencyIds'> & {
  agencyValues?: string[];
  agencyIds?: string[];
};

export const defaultFilterState: TaskFiltersDashboardState = {
  agencyIds: undefined,
  assignedToUserIds: undefined,
};

const taskDashboardFiltersKey = 'taskDashboardFilters';

export const storeDashboardFilterState = (filters: TaskFiltersDashboardState) => {
  try {
    const { agencyIds, ...storedFilters } = filters;
    localStorage.setItem(
      taskDashboardFiltersKey,
      JSON.stringify({ ...storedFilters, agencyValues: agencyIds })
    );
  } catch {
    // Optionally handle storage errors
  }
};

export const createInitialDashboardFilterState = (): TaskFiltersDashboardState => {
  try {
    const storedFilterState = localStorage.getItem(taskDashboardFiltersKey);

    if (!storedFilterState) return defaultFilterState;

    const parsed = JSON.parse(storedFilterState) as StoredTaskFiltersDashboardState;

    if (!parsed) return defaultFilterState;

    const assignedToUserIds = parsed.assignedToUserIds ?? defaultFilterState.assignedToUserIds;

    const agencyIds = parsed.agencyValues ?? parsed.agencyIds ?? defaultFilterState.agencyIds;

    return {
      ...defaultFilterState,
      assignedToUserIds: assignedToUserIds,
      agencyIds: agencyIds,
    };
  } catch {
    return defaultFilterState;
  }
};
